/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationStoreOrderProductDataFromJSON, FxIdApplicationStoreOrderProductDataToJSON, } from './FxIdApplicationStoreOrderProductData';
/**
 * Check if a given object implements the FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsData interface.
 */
export function instanceOfFxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsData(value) {
    if (!('MainProduct' in value) || value['MainProduct'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsDataFromJSON(json) {
    return FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsDataFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'MainProduct': FxIdApplicationStoreOrderProductDataFromJSON(json['MainProduct']),
        'AdditionalProducts': json['AdditionalProducts'] == null ? undefined : (json['AdditionalProducts'].map(FxIdApplicationStoreOrderProductDataFromJSON)),
    };
}
export function FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsDataToJSON(json) {
    return FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsDataToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'MainProduct': FxIdApplicationStoreOrderProductDataToJSON(value['MainProduct']),
        'AdditionalProducts': value['AdditionalProducts'] == null ? undefined : (value['AdditionalProducts'].map(FxIdApplicationStoreOrderProductDataToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsData.js.map